module.exports = __webpack_public_path__ + "img/inactive-list.86a260ac.svg";